import { render } from "./AlertSuccess.vue?vue&type=template&id=555b66f2&scoped=true"
import script from "./AlertSuccess.vue?vue&type=script&lang=js"
export * from "./AlertSuccess.vue?vue&type=script&lang=js"

import "./AlertSuccess.vue?vue&type=style&index=0&id=555b66f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-555b66f2"]])

export default __exports__